<template>
    <b-container>
        <b-row>
            <!-- <h1>Formulários Próprios - Da empresa</h1> -->
            <h2>Formulários compartilhados</h2>
            <success-fade-alert ref="alert" msg="Formulário exluido com sucesso" />
            <fade-alert-danger ref="danger" msg="Formulário não exluido"  />
        </b-row>
        <br>
        <b-row>
            <b-table ref="MyForm" class="table-nowrap" :busy.sync="isBusy" :items="myProvider"
            :fields="fields" :per-page="tablePerPage" :current-page="tableCurrentPage">
              <template v-slot:cell(id)="data">
                    <b-col class="buttons">
                        <router-link to="/checklist/Layout/form/Create/">
                            <b-button size="sm">{{ $t("checklist.form.necklace") }}</b-button>
                        </router-link>                            
                        <router-link :to="'/checklist/Layout/form/Fill/'+ data.value" >
                            <b-button size="sm">{{ $t("checklist.sidebar.Fill") }}</b-button>
                        </router-link>
                    </b-col>
                </template>
            </b-table>
        </b-row>
        <b-row>
            <b-col>
                <b-pagination v-model="tableCurrentPage" :total-rows="tableRowCount" :per-page="tablePerPage"
                first-number last-number aria-controls="table-tabela-proceda" />
            </b-col>
            <b-col>
                <label for="perPageSelect">Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{ tableRowCount }}</label>
            </b-col>
            <b-col>
                <b-row>
                    <b-col>
                        <b-form-select v-model="tablePerPage" id="perPageSelect" size="sim" :options="tablePageOptions" />
                    </b-col>
                    <b-col>
                        <label for="perPageSelect">Registros exibidos por página</label>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
    components: {
        FadeAlertDanger, SuccessFadeAlert,
    },
    data: function() {
        return {
            isBusy: false,
            fields: [
                { key: "id", sortable: false, label: "", tdClass:"checklist-shared-table-col-buttons", },
                { key: "ativo", sortable: true,label: "Ativo", tdClass:"checklist-shared-table-col-ativo", },
                { key: "nome", sortable: true, },
            ],
            tableRowCount: 0,
            tablePerPage: 10,
            tablePageOptions: [5, 10, 25, 50, 100, 150],
            tableCurrentPage: 1,
            tableSelectMode: "single",
            tableSelectedItem: [],
        }
    },
    computed: {
        paginationFrom() {
            return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
        },
        paginationTo() {
            let to = this.paginationFrom - 1 + this.tablePerPage;
            if (to > this.tableRowCount) return this.tableRowCount;
            return to;
        },
    },
    methods: {
        myProvider(ctx) {
            this.isBusy = true;
            return this.$apiChecklist.get("/form/shared/" + ctx.currentPage + "/" + ctx.perPage)
            .then((response) => {
                const items = response.data.items;
                this.isBusy = false;
                this.tableRowCount = response.data.totalItems;
                return items;
            }).catch((error) => {
                if(error.response.status == 401) {
                    // this.$store.dispatch("logout").then(() => {
                    //     this.$router.push("/login");
                    // });
                } else {
                    this.isBusy = false;
                    this.tableRowCount = 0;
                    return [];
                }
            })
        },
        // necklaceForm() {
            
        // },
        deleteForm(id) {
            this.$apiChecklist.get("/form/delete/" + id.toString())
            .then((response) => {
                this.$refs.MyForm.refresh();
                this.$refs.alert.show();
            }).catch((error) => {
                console.log(error.response);
                this.$refs.danger.msg = error.response.status + " - " + error.response.statusText;
                this.$refs.danger.show();
            })
        },
    }
}
</script>

<style>


.checklist-shared-table-col-buttons {
    width: 250px;
}

.checklist-shared-table-col-ativo {
    width: 60px;
}

</style>

<style scoped>

.list {
    margin-left: 24%;
}

.buttons {
    display: flex;
    justify-content: space-evenly;
}

.buttons b-button {
    width: 50%;
}

</style>